import React from "react";
import { Box, Card, Typography, Divider } from "@mui/material";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import pxToRem from "assets/theme/functions/pxToRem";
import { Colors } from "utils/Constants";
import LegalLayout from "./LegalLayout";

const termsList = [
  {
    id: "term-agree",
    text: "By using the Finvibes website or mobile app, you agree to our Terms & Conditions and Privacy Policy.",
  },
  {
    id: "term-compare",
    text: "Finvibes helps you compare, apply and track loans. However, final approval, interest rates, fees and conditions are decided by the respective banks/NBFCs.",
  },
  {
    id: "term-accurate",
    text: "You must provide accurate personal and financial information for loan processing. The information you provide will be used only for loan-related services.",
  },
  {
    id: "term-approval",
    text: "Loan approval is not guaranteed. Each lender follows its own eligibility and verification process.",
  },
  {
    id: "term-login",
    text: "Your login details are your responsibility. Finvibes is not liable for unauthorized access caused by sharing or misuse of your account.",
  },
  {
    id: "term-charges",
    text: "Some services may include charges, which will always be clearly informed in advance.",
  },
  {
    id: "term-comms",
    text: "By signing up, you agree to receive updates, alerts, and communication from Finvibes via SMS, WhatsApp, email, or phone.",
  },
  {
    id: "term-delays",
    text: "Finvibes is not responsible for delays, rejection, or issues arising from lender decisions or third-party services.",
  },
  {
    id: "term-privacy",
    text: "Your data is handled securely as per our Privacy Policy. We take all reasonable measures to protect your information.",
  },
  {
    id: "term-updates",
    text: "Finvibes may update or modify these terms at any time. Continued use of the app after an update means you accept the revised terms.",
  },
];

function TermsAndConditions() {
  return (
    <LegalLayout>
      <Card
        sx={{
          p: { xs: 3, sm: 5, md: 6 },
          borderRadius: "16px",
          border: "1px solid #E2E8F0",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.04)",
          backgroundColor: Colors.WHITE,
        }}
      >
        {/* Header */}
        <Typography
          variant="h3"
          sx={{
            fontSize: { xs: pxToRem(24), sm: pxToRem(30) },
            fontWeight: 800,
            color: "#0F172A",
            letterSpacing: "-0.5px",
            mb: 0.5,
          }}
        >
          Terms & Conditions
        </Typography>
        <Typography
          sx={{
            fontSize: pxToRem(15),
            fontWeight: 600,
            color: Colors.PRIMARY,
            mb: 2.5,
          }}
        >
          Welcome to Finvibes
        </Typography>

        <Divider sx={{ borderColor: "#E2E8F0", mb: 3.5 }} />

        {/* Content Clauses */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
          {termsList.map((clause) => (
            <Typography
              key={clause.id}
              sx={{
                fontSize: pxToRem(14),
                color: "#334155",
                lineHeight: 1.75,
                fontWeight: 400,
              }}
            >
              {clause.text}
            </Typography>
          ))}
        </Box>

        {/* Important Banner */}
        <Box
          sx={{
            mt: 4.5,
            p: 2.5,
            borderRadius: "12px",
            backgroundColor: "#EEF4FF",
            border: "1px solid #D0E1FD",
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: "50%",
              backgroundColor: "#DBEAFE",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <VerifiedUserOutlinedIcon sx={{ color: Colors.PRIMARY, fontSize: pxToRem(22) }} />
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: pxToRem(14.5),
                fontWeight: 700,
                color: "#1E3A8A",
                lineHeight: 1.3,
              }}
            >
              Important
            </Typography>
            <Typography
              sx={{
                fontSize: pxToRem(13),
                color: Colors.PRIMARY,
                mt: 0.25,
              }}
            >
              Please read these terms carefully before using the app.
            </Typography>
          </Box>
        </Box>
      </Card>
    </LegalLayout>
  );
}

export default TermsAndConditions;
